import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisabledDirective } from './disabled.directive';
import { DropdownDirective } from './dropdown.directive';


// Developer CAN USE THIS MODULE FOR Directive/Pipe etc


@NgModule({
  declarations: [
    DisabledDirective,
    DropdownDirective
  ],
  exports: [
    DisabledDirective,
    DropdownDirective
  ],
  imports: [
    CommonModule
  ]
})
export class HelperModule { }
